const redirectParam = "redirect";

export const normalizePostLoginRedirectPath = ( redirectPath?: string | null ) => {
  if( !redirectPath ) return null;

  const sanitizedRedirectPath = redirectPath.trim();

  if( !sanitizedRedirectPath || !sanitizedRedirectPath.startsWith("/") || sanitizedRedirectPath.startsWith("//") ) {
    return null;
  }

  try {
    const url = new URL( sanitizedRedirectPath, window.location.origin );

    if( url.origin !== window.location.origin ) return null;

    return `${ url.pathname }${ url.search }${ url.hash }`;
  } catch {
    return null;
  }
};

export const buildSessionExpiredLoginUrl = ( currentPath = `${ window.location.pathname }${ window.location.search }${ window.location.hash }` ) => {
  const redirectPath = normalizePostLoginRedirectPath( currentPath );

  if( !redirectPath || redirectPath === "/" ) return "/";

  const params = new URLSearchParams({
    [ redirectParam ]: redirectPath,
  });

  return `/?${ params.toString() }`;
};

export const getPostLoginRedirectPath = ( search = window.location.search ) => {
  const params = new URLSearchParams( search );

  return normalizePostLoginRedirectPath( params.get( redirectParam ));
};
